"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.snakeymouse1 = void 0;
const snakeymouse1 = {
  name: 'snakeymouse1',
  guWidth: 500,
  guHeight: 500,
  backgrounds: {
    'rawbRadical1Background': {
      zIndex: 0,
      parallaxSpeed: [-0.9, -0.9]
    },
    'rawbRadical2Background': {
      zIndex: 1,
      parallaxSpeed: [-0.6, -0.6]
    },
    'rawbRadical3Background': {
      zIndex: 2,
      parallaxSpeed: [-0.5, -0.5]
    }
  }
};
exports.snakeymouse1 = snakeymouse1;